import React, {useContext} from 'react';
import {Platform, Pressable, View} from 'react-native';

import Text from '../../elements/Text';
import DashedDivider from '../../elements/DashedDivider';
import ProductCard from '../ProductCard';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {shopContext} from '../../../contexts/ShopContext';
import {DownArrowIcon, UpArrowIcon} from '../../../utils/SvgIcons';

const CartItemCard = ({item, index, setProductBeingViewed}) => {
  const ShopC = useContext(shopContext);
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);

  const onPressUpArrow = () => {
    let items = [...ShopC.cartProducts];
    let product = items[index];
    product.productQty = product.productQty + 1;
    ShopC.setCartProducts(items);
  };

  const onPressDownArrow = () => {
    let items = [...ShopC.cartProducts];
    let product = items[index];
    product.productQty = product.productQty - 1;
    ShopC.setCartProducts(items);
  };

  const onDeleteItem = () => {
    let items = [...ShopC.cartProducts];
    const _ = items.splice(index, 1);
    ShopC.setCartProducts(items);
  };

  return (
    <View style={styles.container}>
      <ProductCard
        showMenu
        imageStyle={styles.productImage}
        style={styles.productInfoView}
        product={item}
        onDelete={onDeleteItem}
        setProductBeingViewed={setProductBeingViewed}
      />
      <View style={styles.marginVertical16}>
        <DashedDivider color={colors.border} dashWidth={5} space={5} />
      </View>
      <View style={styles.rowContainer}>
        <View style={styles.rowItem(0)}>
          <Text variation="Text1SemiBold" color={colors.textMuted}>
            Qty
          </Text>
          <View style={styles.qtyContainer}>
            <Pressable
              hitSlop={{top: 20, left: 20, bottom: 20, right: 20}}
              onPress={onPressDownArrow}
              disabled={item.productQty == 1}
              style={styles.arrowImgContainer}>
              <DownArrowIcon
                width={Platform.OS === 'web' ? 8 : 10}
                height={Platform.OS === 'web' ? 8 : 6}
                tintColor={
                  item.productQty == 1
                    ? colors.borderMuted
                    : Platform.OS === 'web'
                      ? colors.link
                      : colors.textPrimary
                }
              />
            </Pressable>
            <View style={styles.qtyTextContainer}>
              <Text variation="Body1Regular" color={colors.textPrimary}>
                {item.productQty}
              </Text>
            </View>
            <Pressable
              hitSlop={{top: 20, left: 20, bottom: 20, right: 20}}
              onPress={onPressUpArrow}
              style={styles.arrowImgContainer}>
              <UpArrowIcon
                width={Platform.OS === 'web' ? 8 : 10}
                height={Platform.OS === 'web' ? 8 : 6}
                tintColor={
                  Platform.OS === 'web' ? colors.link : colors.textPrimary
                }
              />
            </Pressable>
          </View>
        </View>
        <View style={styles.rowItem(16)}>
          {/* Uncomment below code whenever need to show color options */}
          {/* <Text variation="Text1SemiBold" color={COLORS.grey2}>
            Color
          </Text>
          <View style={styles.qtyContainer}>
            <View style={styles.colorTextContainer}>
              <Text variation="Body1Regular" color={COLORS.black}>
                Black
              </Text>
            </View>
            <View style={styles.arrowImgContainer}>
              <DownArrowIcon
                tintColor={
                  Platform.OS === 'web' ? COLORS.mainLargeText : COLORS.black
                }
              />
            </View>
          </View> */}
        </View>
      </View>
    </View>
  );
};

export default CartItemCard;
